import { getCookie, setCookie } from '../cookie';
import { guid } from '../streams/utils';
import { isBlank } from '../../common/utils/isBlank';

const SESSION_ID = 'Nike.SESSION_ID_TE'; //sessionId for tracking event

export function getSessionId() {
    const existingSessionId = getCookie(SESSION_ID) || '';

    if (!isBlank(existingSessionId)) {
        return existingSessionId;
    }

    return generateSessionId();
}

export function generateSessionId() {
    const existingSessionId = getCookie(SESSION_ID) || '';

    if (!isBlank(existingSessionId)) {
        return existingSessionId;
    }

    return setCookie(SESSION_ID, guid(), 0);
}

export function getDeviceId() {
    return getCookie('Nike.UUID') || '';
}

export const isRecentNikeTvVisitor = () => {
    const lastVisit = sessionStorage.getItem('nikeTvVisit') || 0;
    const twoHoursAgo = new Date().getTime() - 2 * 60 * 60 * 1000;
    const lastVisitTime = new Date(lastVisit).getTime();
    return lastVisitTime > twoHoursAgo;
};

export const markNikeTvVisit = () => {
    sessionStorage.setItem('nikeTvVisit', new Date().toString());
};
